import { clearDigits, formatDate, formatWhatsAppUrl } from 'src/utils/formatters'

export const MAX_PROFILE_PICTURE_SIZE = '3 MB'

export const acceptedImageFileTypes = ['image/jpeg', 'image/webp', 'image/png']

export const monthsArray = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
]

export const smallMonthsArray = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez'
]

export const statesOptions = [
  {
    abbr: 'AC',
    name: 'Acre'
  },
  {
    abbr: 'AL',
    name: 'Alagoas'
  },
  {
    abbr: 'AP',
    name: 'Amapá'
  },
  {
    abbr: 'AM',
    name: 'Amazonas'
  },
  {
    abbr: 'BA',
    name: 'Bahia'
  },
  {
    abbr: 'CE',
    name: 'Ceará'
  },
  {
    abbr: 'DF',
    name: 'Distrito Federal'
  },
  {
    abbr: 'ES',
    name: 'Espírito Santo'
  },
  {
    abbr: 'GO',
    name: 'Goiás'
  },
  {
    abbr: 'MA',
    name: 'Maranhão'
  },
  {
    abbr: 'MT',
    name: 'Mato Grosso'
  },
  {
    abbr: 'MS',
    name: 'Mato Grosso do Sul'
  },
  {
    abbr: 'MG',
    name: 'Minas Gerais'
  },
  {
    abbr: 'PA',
    name: 'Pará'
  },
  {
    abbr: 'PB',
    name: 'Paraíba'
  },
  {
    abbr: 'PR',
    name: 'Paraná'
  },
  {
    abbr: 'PE',
    name: 'Pernambuco'
  },
  {
    abbr: 'PI',
    name: 'Piauí'
  },
  {
    abbr: 'RJ',
    name: 'Rio de Janeiro'
  },
  {
    abbr: 'RN',
    name: 'Rio Grande do Norte'
  },
  {
    abbr: 'RS',
    name: 'Rio Grande do Sul'
  },
  {
    abbr: 'RO',
    name: 'Rondônia'
  },
  {
    abbr: 'RR',
    name: 'Roraima'
  },
  {
    abbr: 'SC',
    name: 'Santa Catarina'
  },
  {
    abbr: 'SP',
    name: 'São Paulo'
  },
  {
    abbr: 'SE',
    name: 'Sergipe'
  },
  {
    abbr: 'TO',
    name: 'Tocantins'
  }
]

export const defaultAddress = {
  cep: '',
  country: '',
  state: '',
  city: '',
  neighborhood: '',
  street: '',
  number: '',
  complement: '',
  reference: ''
}

export const STATUS_SINGLE = 'Solteiro'
export const STATUS_MARRIED = 'Casado'
export const STATUS_SEPARATED = 'Separado'
export const STATUS_DIVORCED = 'Divorciado'
export const STATUS_WIDOWED = 'Viúvo'

export const maritalStatus = [
  STATUS_SINGLE,
  STATUS_MARRIED,
  STATUS_SEPARATED,
  STATUS_DIVORCED,
  STATUS_WIDOWED
]

export const booleanOptions = [
  { label: 'Sim', value: true },
  { label: 'Não', value: false }
]

export const PHONE_ATENDIMENTO_GERAL = '5527996947753'
export const PHONE_ATENDIMENTO_CONCIERGE = '5527999181373'
export const PHONE_COMERCIAL = '5527997799448'
export const PHONE_ASSESSORIA = '5527996541154'

export const redirectAtendimentoWhatsapp = (message = '', isConcierge = false) => {
  const phone = isConcierge ? PHONE_ATENDIMENTO_CONCIERGE : PHONE_ATENDIMENTO_GERAL

  return formatWhatsAppUrl(phone, message)
}

export const serviceWhatsappUrl = (isConcierge) => redirectAtendimentoWhatsapp('Olá, estou com algumas dúvidas. Vocês podem me ajudar?', isConcierge)

export const notificationsSupportUrl = (isConcierge) => redirectAtendimentoWhatsapp('Olá, estou com dificuldades para ativar as notificações no App da Docstage.', isConcierge)

export const complianceWhatsappUrl = (isConcierge) => redirectAtendimentoWhatsapp('Olá, gostaria de suporte sobre algumas questões jurídicas.', isConcierge)

export const serviceWhatsappNotificationsHelpUrl = (isConcierge) => redirectAtendimentoWhatsapp('Olá, gostaria de ajustar algumas notificações da Docstage. Vocês podem me ajudar?', isConcierge)

export const signContractHelpUrl = (isConcierge) => redirectAtendimentoWhatsapp('Olá, estou com dificuldades para assinar o contrato no App da Docstage.', isConcierge)

export const commercialWhatsappUrl = formatWhatsAppUrl(PHONE_COMERCIAL, 'Olá, estou com algumas dúvidas no app da Docstage')

export const financialAdvisoryWhatsappUrl = formatWhatsAppUrl(PHONE_ASSESSORIA, 'Olá, gostaria de conversar sobre Assessoria Patrimonial e Financeira.')

export const CENTRAL_DE_AJUDA_URL = 'https://ajuda.docstage.com.br/hc/pt-br'

export const asaasSecondCopy = 'https://www.asaas.com/segunda-via'

export const downloadRequestDataFormUrl = 'https://docstage-public.s3.sa-east-1.amazonaws.com/DOCSTAGE+-+Formula%CC%81rio+do+Exerci%CC%81cio+do+Direito+do+Titular+-+2022.06.10+-+MMadv-1.docx'

export const YEAR_OF_LAUNCH = 2022

export const BANK_CORA_URL = 'https://lp.cora.com.br/coraliados?code=docstage-servicos-contabeis&n=Docstage%20Servicos%20Contabeis'

export const TWO_FACTOR_TUTORIAL_URL = 'https://docstage.sharepoint.com/:b:/s/DocstageServiosIntegradosLTDA/EY25JdB1XEBDu_79Ds4CGyABtxQan7FXOie-Yjm5WSK6Ww'

export const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const romanPattern =
  /^M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/

export const DEFAULT_ROWS_PER_PAGE = 50

export const APP_STORE_URL = 'https://apps.apple.com/br/app/docstage/id1604446803'

export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=br.com.docstage.app.twa'

export const DEFAULT_CORPORATE_DATA = {
  type: null,
  shareholders: [],
  email: null,
  size: null,
  opening: null,
  phones: [],
  share_capital: null,
  main_activity: {
    code: null,
    text: null
  },
  secondary_activities: [],
  situation_date: null,
  legal_nature: null,
  special_situation: null,
  special_situation_date: null,
  situation: null,
  situation_reason: null,
  last_updated_at: null
}

export const DEFAULT_ADDRESS = {
  cep: '',
  state: '',
  city: '',
  street: '',
  complement: '',
  number: '',
  neighborhood: '',
  state_id: null,
  city_id: null
}

export const DEFAULT_INTERNATIONAL_ADDRESS = {
  ...DEFAULT_ADDRESS,
  zip_code: '',
  country_id: ''
}

export const API_DATA_TO_CORPORATE_DATA_FIELDS = [
  [
    'abertura',
    'opening',
    val => /^\d{2}\/\d{2}\/\d{4}$/.test(val) ? val.split('/').reverse().join('-') : ''
  ],
  [
    'atividade_principal',
    'main_activity',
    val => val[0] ?? null
  ],
  ['atividades_secundarias', 'secondary_activities'],
  ['capital_social', 'share_capital', val => parseFloat(val)],
  ['email', 'emails', val => (Array.isArray(val) && val) || [val]],
  ['natureza_juridica', 'legal_nature'],
  [
    'telefone',
    'phones',
    val => String(val).split('/').map(val => clearDigits(val).substring(0, 11))
  ],
  ['tipo', 'type'],
  ['situacao', 'situation'],
  [
    'data_situacao',
    'situation_date',
    val => formatDate(val, 'YYYY-MM-DD', 'DD/MM/YYYY')
  ],
  ['situacao_especial', 'special_situation'],
  [
    'data_situacao_especial',
    'special_situation_date',
    val => val ? formatDate(val, 'YYYY-MM-DD', 'DD/MM/YYYY') : ''
  ]
]

export const DEFAULT_SIZE_PROP = (defaultSize = 'sm') => {
  return {
    type: String,
    default: defaultSize,
    validator: val => ['xs', 'sm', 'md', 'lg', 'xl'].includes(val)
  }
}

export const DEFAULT_TABLE_PAGINATION_COUNT = 50
export const DEFAULT_AUTOCOMPLETE_PAGINATION_COUNT = 20

export const BRAND_NAME = 'Docstage'
